module.exports = __webpack_public_path__ + "assets/img/Discover-Massage-Australia-eBook-w540.c73a6e42.webp";